import React from "react"
import { Col, Row } from "reactstrap"
import PropTypes from "prop-types"
import { SaveButton } from "components/Buttons"

const DeleteCategoryModal = ({ hideModalHandler, handleDelete }) => {
  return (
    <React.Fragment>
      <Row>
        <h5>Are you sure you want to delete this category?</h5>
      </Row>
      <Row className="mt-2">
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={hideModalHandler}
          />
        </Col>
        <Col>
          <SaveButton
            content="Delete"
            fullWidth={true}
            onClick={handleDelete}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

DeleteCategoryModal.propTypes = {
  hideModalHandler: PropTypes.func,
  handleDelete: PropTypes.func,
}

export default DeleteCategoryModal
